<script>
	import Banner from "./Banner.svelte";
	import ResultsTable from "./ResultsTable.svelte";
	import Stats from "./Stats.svelte";
	import Timestamp from "./Timestamp.svelte";

	let urlParams = new URLSearchParams(window.location.search);
	const framed = urlParams.has('iframe');
	let settings;
	let results;
	let title;

	
	let refreshTimer;
	let refreshTimeout = 60000; //start with 1 minute

	(async () => {
		settings = await fetch('settings.json').then(r => r.json());
		loadResults();
		refreshTimeout = settings.refreshTimeout || 60000;
		refreshTimer = setInterval(loadResults,refreshTimeout);
	})();


	async function loadResults(){
		results = await fetch(settings.endpoint,{cache:"no-cache"}).then(r => r.json());
		title = results.statistics.projectName;
	}
</script>

<svelte:head>
	<title>{title?title:'City of Victoria Voting Results'}</title>
</svelte:head>

{#if title && !framed}
<Banner h1="{title}"></Banner>
{/if}

<main>
	<div class="container">
		{#if results && Object.keys(results).length>0}
			<div>
				<Timestamp timestamp={results.statistics.timeStamp} />
			</div>
			<section>
				<Stats
					{...results.statistics}
				/>
			</section>
	
			<section class="table-container">
				<table>
				{#each results.areaResults[0][settings.config.areaID].contestResults as contest}
				<tbody id="results{contest.id}">
					<ResultsTable
						voteFor={contest.voteFor}
						contestName={contest.contestName}
						results={contest.choiceResults}
					/>
				</tbody>
				{/each}
			</table>
		</section>
		{/if}
	</div>
</main>

<style>

	:root {
		--covBlue: #017eb5;
		--tableTitleColour: var(--covBlue);
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
	}

	.table-container {
		overflow-x: auto;
	}

	section {
		margin: 2em;
	}

	table {
		width: 100%;
		max-width: 100%;
	}

</style>
